import { render, staticRenderFns } from "./DepartureSummary.vue?vue&type=template&id=29fd63d8&"
import script from "./DepartureSummary.vue?vue&type=script&lang=js&"
export * from "./DepartureSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports